import {Badge, Icon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export const BankCheckTransferBadge: FC = () => {
  const {t} = useTranslation('trustAccounts');

  return (
    <Badge variant="purple" size="sm">
      <Icon name="bank-note" className="size-3" />
      {t('view.payouts.list.transferTypes.bank_check')}
    </Badge>
  );
};
